import SEO from "@/components/SEO";
import NewHereSection from "@/components/home/NewHereSection";
import { useTranslation } from "@/hooks/useTranslation";
import HeroCircle from "@/components/home/HeroCircle";

const Index = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen relative overflow-hidden bg-background">
      <SEO path="/" />
      <main>
        {/* Hero Section */}
        <section id="hero" className="home-paper relative pt-32 md:pt-40 pb-12 md:pb-20">
          <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
            <header className="relative mb-12 md:mb-16 max-w-4xl">
              <div className="relative inline-block max-w-full">
                <h1 className="home-display relative text-5xl sm:text-7xl md:text-8xl font-extrabold leading-[0.95] text-foreground">
                  {t.home.hero.title1
                    .replace(" Guide", "")
                    .split(" ")
                    .map((word, i) => (
                      <span key={i}>{word} </span>
                    ))}
                  <span className="block italic font-semibold text-secondary">Guide.</span>
                  <span className="sr-only"> — {t.home.hero.title2} {t.home.hero.title3} {t.home.hero.title4}</span>
                </h1>
              </div>
              <p className="mt-6 text-lg md:text-2xl font-normal text-muted-foreground max-w-2xl leading-relaxed hero-subtitle-ru">
                {t.home.hero.title2} {t.home.hero.title3} {t.home.hero.title4}
              </p>
            </header>
            <HeroCircle />
          </div>
        </section>
        
        {/* New Here Section (includes CTA button) */}
        <NewHereSection />
      </main>
    </div>
  );
};

export default Index;
